module.exports = __webpack_public_path__ + "img/pirate.fea39b43.png";